import { CardIcon, LoopButton, Modal, Typography } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { ShruggingGraphic } from '../../../assets/img';
import WithThemeProvider from '../../../theme/WithThemeProvider';
import {
    StyledModularValidationDependentModal,
    StyledModularValidationDependentModalBody,
    StyledModularValidationDependentModalContent,
    StyledModularValidationDependentModalContentText,
    StyledModularValidationDependentModalFooter
} from './styles';
import { IModularValidationDependentModal } from './types';
import { Loader } from '../../atoms';

const ModularValidationDependentModal: React.FC<IModularValidationDependentModal> = ({
    isVisible,
    setIsVisible,
    validationModal,
    onConfirmDelete,
    onConfirmUpdate,
    isSubmitting
}) => {
    const isDelete = validationModal?.mode === 'delete';
    const onConfirm = () => {
        if (isDelete) onConfirmDelete();
        else onConfirmUpdate();
    };
    const handleClose = () => {
        if (isSubmitting || validationModal?.loading) return;
        setIsVisible();
    };
    return (
        <Modal isVisible={isVisible} setIsVisible={handleClose} disablePadding>
            <WithThemeProvider>
                <StyledModularValidationDependentModal>
                    <img src={ShruggingGraphic} />
                    {validationModal?.loading ? (
                        <Loader minHeight="100px" />
                    ) : (
                        <>
                            <StyledModularValidationDependentModalBody>
                                <Typography variant="title2" weight="medium">
                                    {isDelete
                                        ? `Removing ${validationModal?.relationship} will lead to removal of add-ons`
                                        : ` Updated ${validationModal?.relationship} Details ` +
                                          `will lead to removal of add-on`}
                                </Typography>
                                <StyledModularValidationDependentModalContent>
                                    <Typography variant="small" weight="medium">
                                        Add-on getting removed
                                        {!isDelete && `, as ${validationModal?.relationship} is no longer eligible`}
                                    </Typography>
                                    {validationModal?.invalidBenefits?.map((ib) => (
                                        <StyledModularValidationDependentModalContentText key={ib.id}>
                                            <CardIcon imageUrl={ib.metadata.logo} />
                                            <Typography variant="medium" weight="semiBold">
                                                {ib.name}
                                            </Typography>
                                        </StyledModularValidationDependentModalContentText>
                                    ))}
                                </StyledModularValidationDependentModalContent>
                            </StyledModularValidationDependentModalBody>
                            <StyledModularValidationDependentModalFooter>
                                <LoopButton onClick={handleClose} variant="secondary">
                                    Never Mind
                                </LoopButton>
                                <LoopButton onClick={onConfirm} variant="filled" isLoading={isSubmitting}>
                                    {isDelete ? `Confirm & Remove` : `Confirm & Update`}
                                </LoopButton>
                            </StyledModularValidationDependentModalFooter>
                        </>
                    )}
                </StyledModularValidationDependentModal>
            </WithThemeProvider>
        </Modal>
    );
};

export default ModularValidationDependentModal;
